export const contactUs = '/public/save-contact-us-form'
export const subscription = '/public/save-subscription'